import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Circle, Path} from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function WarningIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 64 64">
      <G>
        <G fill={color}>
          <Circle cx="32.086" cy="50.142" r="2.256" fill={color}/>
          <Path d="m30.08,25.012v17.308c0,1.107 0.897,2.005 2.006,2.005s2.006-0.897 2.006-2.005v-17.308c0-1.107-0.897-2.006-2.006-2.006s-2.006,0.898-2.006,2.006z" fill={color}/>
          <Path d="M63.766,59.234L33.856,3.082c-0.697-1.308-2.844-1.308-3.54,0L0.407,59.234    c-0.331,0.622-0.312,1.372,0.051,1.975c0.362,0.605,1.015,0.975,1.72,0.975h59.816c0.705,0,1.357-0.369,1.721-0.975    C64.076,60.606,64.096,59.856,63.766,59.234z M5.519,58.172L32.086,8.291l26.568,49.881H5.519z" fill={color}/>
        </G>
      </G>
    </Svg>

  );
}

WarningIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

WarningIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(WarningIcon);
